import { useOnRateChangeJobUpdateSubscription } from '@/features/rate-change/gql/_gen_/rate-change.gql';
import { selectJobId } from '@/features/rate-upload/redux/rate-upload-selectors';
import { setJobId } from '@/features/rate-upload/redux/rate-upload-slice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import _ from 'lodash';
import { useEffect, useMemo } from 'react';

export const RateChangeJobStatus = () => {
	const jobId = useAppSelector(selectJobId);
	const dispatch = useAppDispatch();

	// Reset jobId after 30 seconds
	useEffect(() => {
		if (jobId) {
			const timer = setTimeout(() => {
				dispatch(setJobId(undefined));
			}, 30000);

			return () => clearTimeout(timer);
		}
	}, [jobId, dispatch]);

	const { data, error } = useOnRateChangeJobUpdateSubscription({
		skip: !jobId,
		variables: {
			id: jobId!,
		},
	});

	const jobStatus = useMemo(() => {
		console.log('data', data);
		console.log('error', error);
		console.log('jobId', jobId);

		if (error) return error.message;
		if (!data) return null;

		const job = data.onRateChangeJobUpdate;

		const message = `Job Status - ${_.startCase(job?.jobStatus)} | Rates - ${
			job?.rates?.length ?? 0
		}`;

		return message;
	}, [data, error, jobId]);

	return (
		<div className='tw-flex tw-text-sky-700'>
			<p>{jobStatus}</p>
		</div>
	);
};
